import { render } from "./SubscriptionSummary.vue?vue&type=template&id=20ce5c12"
import script from "./SubscriptionSummary.vue?vue&type=script&lang=js"
export * from "./SubscriptionSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__